import React from "react";
import { connect } from "react-redux";

import * as actions from "../actions/actions";

import { SiteHeader } from "core/SiteHeader";

import { Link } from "core/SiteHeader/styles";
import { Join } from "./ProfileMenu/styles";
import { GrayButton } from "./core/Button";

import { authLinks } from "../data/links";

import logOutAndRedirect from "../helpers/log-out";

const LoginLinkUnwrapped = ({ redirect }) => {
    const toEncode = `${window.location.pathname}${window.location.search}`;
    const encodedUrl = encodeURIComponent(toEncode);

    const logIn = e => {
        e.preventDefault();
        redirect(`${authLinks.login.href}?next=${encodedUrl}`);
    };

    return (
        <Link
            data-test="login-link"
            href={authLinks.login.href}
            title="Log in"
            onClick={logIn}
        >
            {authLinks.login.text}
        </Link>
    );
};

const LoginLink = connect(null, { redirect: actions.redirect })(
    LoginLinkUnwrapped
);

const JoinLinkUnwrapped = ({ redirect }) => {
    const toEncode = `${window.location.pathname}${window.location.search}`;
    const encodedUrl = encodeURIComponent(toEncode);

    const handleJoin = e => {
        e.preventDefault();
        redirect(`${authLinks.signup.href}?next=${encodedUrl}`);
    };

    return (
        <Join href={authLinks.signup.href} title="Join" onClick={handleJoin}>
            <GrayButton size="small" width="3.625rem">
                {authLinks.signup.text}
            </GrayButton>
        </Join>
    );
};

const JoinLink = connect(null, { redirect: actions.redirect })(
    JoinLinkUnwrapped
);

class NounProjectHeader extends React.Component {
    componentWillMount() {
        this.props.getCurrentUser();
    }

    constructor(props) {
        super(props);
    }

    render() {
        const handleLogOut = () => {
            logOutAndRedirect();
        };

        const currentUser = this.props.currentUser;

        return (
            <>
                <SiteHeader
                    currentUser={currentUser}
                    loginLink={<LoginLink />}
                    joinLink={<JoinLink />}
                    handleLogOut={handleLogOut}
                />
            </>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser = {};

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    const hasTeams =
        currentUser.teams && currentUser.teams.length > 0
            ? currentUser.teams
            : [];

    const currentUserTeams = hasTeams
        .filter(team => {
            return team.user_is_owner;
        })
        .map(team => {
            return {
                name: team.name,
                username: team.slug
            };
        });

    const hasPermissions =
        currentUser.permissions && currentUser.permissions.length > 0
            ? currentUser.permissions
            : {};

    return {
        currentUser: {
            id: currentUser.id,
            username: currentUser.username,
            avatarUrl: currentUser.avatar,
            isCreator: currentUser.creator,
            isSuperuser: currentUser.is_superuser,
            isAnonymous: currentUser.is_anonymous,
            hasSubscription: currentUser.has_premium_account,
            hasNotifications: currentUser.has_notifications,
            hasApiKey: currentUser.has_api_key,
            csrf: currentUser.csrf,
            ownedTeams: currentUserTeams,
            permissions: hasPermissions
        }
    };
}

export default connect(mapStateToProps, {
    getCurrentUser: actions.getCurrentUser
})(NounProjectHeader);
